/* eslint-disable */
import * as React from "react";

import { useParameter } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { UnitsControl } from "../controls/UnitsControl";
import { CommoditiesControl } from "../controls/CommoditiesControl";
import { BusinessUnitControl } from "../controls/BusinessUnitControl";

import { useFavourite } from "./useFavourite";
export default function () {
  const [business] = useParameter<number>("@business-units");
  useFavourite();
  return (
    <ReportToolbarGroup vertical>
      <BusinessUnitControl />
      <CommoditiesControl key={business || undefined} />
      <UnitsControl />
    </ReportToolbarGroup>
  );
}
